export default "__VITE_ASSET__CGxFi3vv__"